import { UnitService } from '@application/unit.service';
import { BreakPoints, Flex, Spacer, Text, useBreakpoint } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import { Logo } from '@component/logo.component';
import { Auth } from '@feature/auth';
import { useResolve } from '@visiba/instantiation';
import styled from 'styled-components';
import { IllustrativeDefault } from '../../../../patient/src/views/view_guest/_illustrative.component';
import { SignInController } from './sign_in.controller';

interface Props {
	__TEMP__onCloseSignIn: () => void;
}

export function SignIn(props: Props): JSX.Element {
	const smallBreakpoint = useBreakpoint(BreakPoints.Small);
	const controller = useResolve(SignInController);
	const returnUrl = controller.selectMethod();

	return (
		<OutletIdp {...props}>
			{smallBreakpoint ? <Spacer vertical={tokens.size.x7} /> : null}

			<Flex
				grow='1'
				gap={tokens.spacing.x4}
				style={{
					margin: `0 ${tokens.spacing.x2}`,
					height: '100%',
				}}
				data-testid='sign_in'
			>
				<Auth.Methods returnUrl={returnUrl} />
			</Flex>
		</OutletIdp>
	);
}

const StyledContainer = styled.div`
	width: 100%;
	height: 100%;
	margin: ${tokens.spacing.x2} 0 ${tokens.spacing.x1};

	${tokens.breakpointQuery.large} {
		padding-top: 240px;
		max-width: 500px;
		max-height: 700px;
	}
`;

const StyledHeader = styled.div`
	padding: ${tokens.spacing.x2} ${tokens.spacing.x2} 0;

	${tokens.breakpointQuery.large} {
		padding: 0;
		position: fixed;
		top: ${tokens.spacing.x3};
		left: ${tokens.spacing.x3};
		z-index: 1;
	}
`;

const SideAreaContent = styled.div`
	width: 630px;
`;

const SideArea = styled.div`
	position: fixed;
	right: 0;
	top: 0;
	display: flex;
	width: 630px;
	min-height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-shrink: 0;
	padding: 0px 65px;
	background-color: ${tokens.color.bg.surfaceBrand};
	pointer-events: none;
`;

function OutletIdp(props: React.PropsWithChildren<Props>): JSX.Element {
	const largeBreakpoint = useBreakpoint(BreakPoints.Large);
	const unitService = useResolve(UnitService);

	return (
		<Flex
			grow={1}
			direction='row'
			style={{
				height: '100%',
				minHeight: '100%',
			}}
		>
			<Flex
				grow={1}
				breakpointLargeAndUp={{
					align: 'center',
				}}
			>
				<StyledContainer>
					<StyledHeader>
						<Flex align='center' gap={tokens.spacing.x1} direction='column'>
							<Logo
								onClick={(e) => {
									// We need to manually close the modal containing the sign-in stuff.
									// This is a temporary solution to close the modal.
									e.preventDefault();
									props.__TEMP__onCloseSignIn();
								}}
							/>
							{/* Required by Google Play: a reference to the licence holder entity must appear under the logo */}
							<Text.p variant='labelSmallRegular' color={tokens.color.content.muted}>
								{unitService.rootUnit.name}
							</Text.p>
						</Flex>
					</StyledHeader>

					{props.children}
				</StyledContainer>
			</Flex>

			{largeBreakpoint ? (
				<SideAreaContent>
					<SideArea>
						<IllustrativeDefault />
					</SideArea>
				</SideAreaContent>
			) : null}
		</Flex>
	);
}
